// src/pages/LoginPage.tsx
import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate, useSearchParams } from "react-router-dom";

import LoginSection from "src/components/LoginSection";
import GoogleLoginButton from "src/components/auth/GoogleLoginButton";
import { useAuthStore } from "src/store/Auth/auth.store";

const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  width: 360px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

function hasLocalAuth(): boolean {
  const accessToken = localStorage.getItem("accessToken") || "";
  const userId = localStorage.getItem("userId") || "";
  const userEmail = localStorage.getItem("userEmail") || "";
  // 최소 기준: accessToken + (userId or email)
  return Boolean(accessToken && (userId || userEmail));
}

const LoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setLogin = useAuthStore((s) => s.setLogin);

  useEffect(() => {
    // ✅ 서버에서 callback으로 /login?code=... 로 돌아오는 구조면
    // 여기서 바로 LoginCallback 라우트로 넘겨주는 게 안전함.
    // (LoginPage에서 토큰 교환 로직을 돌리면 컴포넌트 책임이 커지고 루프나기 쉬움)
    const code = searchParams.get("code");
    if (code) {
      navigate(`/login/callback?code=${encodeURIComponent(code)}`, { replace: true });
      return;
    }

    // ✅ 이미 토큰이 있으면 로그인 상태로 처리하고 대시보드로
    if (hasLocalAuth()) {
      setLogin(""); // userToken 안 쓰는 구조면 빈 문자열로 OK (isLoggedIn만 true가 됨)
      navigate("/", { replace: true });
    }
  }, [navigate, searchParams, setLogin]);

  const handleSubmit = (id: string, pw: string) => {
    // 현재는 아이디/비번 로그인 미사용이면 비워두기
  };

  return (
    <Container>
      <Box>
        <LoginSection onSubmit={handleSubmit}>
          {/* ✅ 서버 OAuth 시작 */}
          <GoogleLoginButton />
        </LoginSection>
      </Box>
    </Container>
  );
};

export default LoginPage;
